import { render } from "./z-task-readonly-info.vue?vue&type=template&id=ed26273c"
import script from "./z-task-readonly-info.vue?vue&type=script&lang=js"
export * from "./z-task-readonly-info.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__